<template>
  <div
    v-if="visible"
    class="sf-modal sf-modal-white sf-fixed sf-modal-s sf-level"
  >
    <div class="sf-modal-backdrop" />
    <div class="sf-modal-container">
      <div class="sf-modal-inner">
        <div class="sf-modal-content sf-c-text sf-pad-v-4">
          <p
            v-dompurify-html="
              I18n.t(
                'user.firm_level_configuration.enforce_sso_access.modal.primary_text'
              )
            "
            class="sf-font-m sf-below-3 sf-align-c sf-pad-h-4 sf-below-2"
          />

          <p
            v-dompurify-html="I18n.t(`${secondary_text}`, { action: action })"
            class="sf-bg-warning-subtle sf-pad-3 sf-c-warning-darker sf-below-3"
          />

          <div class="sf-level sf-level-center sf-level-small">
            <button type="button" class="sf-btn sf-level-item" @click="close">
              {{ I18n.t('common.cancel') }}
            </button>
            <button
              type="button"
              class="sf-btn sf-btn-success sf-level-item"
              @click="confirm"
            >
              {{ confirm_message }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      newSetting: '',
      visible: false,
      translationsScope: 'user.firm_level_configuration.enforce_sso_access',
    }
  },

  methods: {
    openModal({ newSetting, form, submitButton }) {
      this.newSetting = newSetting
      this.form = form
      this.submitButton = submitButton
      this.visible = true
      this.action = I18n.t(
        `${this.translationsScope}.actions.${this.newSetting}`
      )

      if (this.newSetting === 'none') {
        this.secondary_text = this.translationsScope + '.modal.secondary_text_2'
        this.confirm_message = I18n.t(
          `${this.translationsScope}.modal.confirm_2`
        )
      } else {
        this.secondary_text = this.translationsScope + '.modal.secondary_text_1'
        this.confirm_message = I18n.t(
          `${this.translationsScope}.modal.confirm_1`,
          { action: this.action }
        )
      }
    },

    close() {
      this.visible = false
      this.submitButton.disabled = false
    },

    confirm() {
      this.form.submit()
      this.visible = false
    },
  },
}
</script>
